/**
 * @fileoverview Agent definition for divergence-report-v2.
 *
 * Analyzes structural divergences between the author's planned story and what
 * was actually written. Receives pre-computed comparison data and applies
 * editorial judgment to surface significant divergences.
 *
 * Reports are ephemeral — generated on demand, not persisted.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'divergence-report-v2',
  kind: 'primitive',
  name: 'Divergence Report',
  description: 'Analyzes structural divergences between the planned story and what was actually written.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'primitives/use-divergence-report-v2.ts',
    ],
    usedInComposites: [
      'structural-refresh-composite-v1',
    ],
    relatedAgents: [
      'storyline-refresher-v2',
      'structural-suggestions-v1',
      'plot-snapshotter-v2',
      'chapter-rebuilder-v1',
    ],
  },
};
